import { styled } from '@linaria/react';

import Free from '~public/assets/icons/freeGiftText.svg';
import FreeNeurons from '~public/assets/icons/freeNeuronsText.svg';
import GiftText from '~public/assets/icons/giftText.svg';
import { MqTablet } from '~theme/media';

export const OpenFeedMobileContainer = styled.div`
	right: 10px;

	&::after {
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		width: 110%;
		height: 110%;
		background: var(--blur-bg);
		content: '';
		filter: blur(15px);
		opacity: unset;
	}
`;

export const FreeGift = styled(Free)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: -15px;
	left: 50%;
	display: block;
	transform: translate(-50%);

	${MqTablet} {
		display: none;
	}
`;

export const GetFreeGift = styled(FreeNeurons)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: -30px;
	left: -25px;
	display: block;

	${MqTablet} {
		display: none;
	}
`;

export const Gift = styled(GiftText)<JSX.IntrinsicElements['svg']>`
	position: absolute;
	bottom: 0;
	left: 50%;
	display: block;
	transform: translate(-50%);

	${MqTablet} {
		display: none;
	}
`;
